var _defs, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _path7, _path8, _line, _path9, _path10, _circle, _circle2, _path11, _circle3, _circle4, _path12, _circle5, _circle6, _path13, _circle7, _path14, _path15, _path16, _path17, _circle8, _circle9, _path18, _circle10, _polygon2, _polygon3, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObj100Mvl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 731 356.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#50bd86;}.cls-2{fill:#434341;}.cls-3{fill:#fff;}.cls-4{fill:#ffdc00;}.cls-5{fill:#aae2c2;}.cls-6{fill:#ffbe09;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.11,286.62a97.84,97.84,0,1,0-97.9-97.83A97.86,97.86,0,0,0,231.11,286.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.1,288.55a99.77,99.77,0,1,1,99.83-99.76A99.9,99.9,0,0,1,231.1,288.55Zm0-195.67a95.91,95.91,0,1,0,96,95.91A96,96,0,0,0,231.1,92.88Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "338.97 108.72 314.16 107.05 312.12 81.87 347.76 46.23 349.61 71.23 374.61 73.08 338.97 108.72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.71,110.7l-27.34-1.83-2.24-27.73,39.25-39.25,2,27.54,27.53,2ZM316,105.24l22.27,1.5,32-32L347.81,73l-1.66-22.45-32,32Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231.11,266.22a77.44,77.44,0,1,0-77.49-77.43A77.46,77.46,0,0,0,231.11,266.22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.1,242.76a54,54,0,1,0-54-54A54,54,0,0,0,231.1,242.76Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.1,244.69A55.91,55.91,0,1,1,287,188.79,56,56,0,0,1,231.1,244.69Zm0-107.95a52,52,0,1,0,52.08,52A52.12,52.12,0,0,0,231.1,136.74Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M231.1,215.84A27.05,27.05,0,1,0,204,188.79,27.07,27.07,0,0,0,231.1,215.84Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.1,217.77a29,29,0,1,1,29-29A29,29,0,0,1,231.1,217.77Zm0-54.1a25.12,25.12,0,1,0,25.14,25.11A25.15,25.15,0,0,0,231.1,163.67Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 231.73,
    y1: 188.23,
    x2: 348.84,
    y2: 71.11
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.73,190.16a1.94,1.94,0,0,1-1.36-3.3L347.48,69.75a1.93,1.93,0,1,1,2.73,2.73L233.1,189.59A1.94,1.94,0,0,1,231.73,190.16Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103,32A23.84,23.84,0,0,1,79.21,8.15h9A14.82,14.82,0,0,0,103,23Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 293.68,
    cy: 32.77,
    r: 7.98
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 495.36,
    cy: 268.23,
    r: 7.98
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M423,63.81A23.84,23.84,0,0,1,399.19,40h9A14.82,14.82,0,0,0,423,54.8Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 411.67,
    cy: 237.78,
    r: 7.98
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 495.82,
    cy: 33.19,
    r: 7.98
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M389.74,172.29a14.82,14.82,0,0,0-20.93,0l-6.37-6.37a23.84,23.84,0,0,1,33.67,0Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 616.21,
    cy: 54.82,
    r: 7.98
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 677.21,
    cy: 265.82,
    r: 7.98
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M49.55,255.14a14.78,14.78,0,0,0-18.49-9.8l-2.65-8.61a23.79,23.79,0,0,1,29.75,15.76Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 90.76,
    cy: 186.87,
    r: 7.98
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M445,316.81A23.84,23.84,0,0,1,421.19,293h9A14.82,14.82,0,0,0,445,307.8Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.45,335.31A14.8,14.8,0,0,0,197,323.75l-1.79-8.83a23.84,23.84,0,0,1,28.06,18.6Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M575.73,297.8a14.81,14.81,0,0,0,4.15,20.51l-5,7.51a23.85,23.85,0,0,1-6.68-33Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.93,77.07A23.84,23.84,0,0,1,25.12,53.26h9a14.81,14.81,0,0,0,14.8,14.8Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 58.25,
    cy: 319.82,
    r: 7.98
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 293.4,
    cy: 307.73,
    r: 7.98
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M49,155.24l-6.37-6.37a14.79,14.79,0,0,0,0-20.93L49,121.57a23.79,23.79,0,0,1,0,33.67Z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 195.5,
    cy: 19.79,
    r: 7.98
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "257.74 84.27 134.13 142.44 114.71 101.17 152.16 101.68 170.95 60.25 214.84 72.19 238.32 43 257.74 84.27"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.45 114.99 138.75 140.26 123.52 107.89 156.06 108.33 172.38 72.34 192.45 114.99"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M451.69,123.91a17.15,17.15,0,0,1,23.44,0,17.55,17.55,0,0,1,0,23.67,17.15,17.15,0,0,1-23.44,0,17.55,17.55,0,0,1,0-23.67Zm6.82,17.39a6.18,6.18,0,0,0,4.88,2.19,6.25,6.25,0,0,0,4.9-2.19,8.92,8.92,0,0,0,0-11.11,6.24,6.24,0,0,0-4.9-2.18,6.17,6.17,0,0,0-4.88,2.18,9,9,0,0,0,0,11.11Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M500.11,120a13.61,13.61,0,0,1,8.59,2.54,8,8,0,0,1,3.29,6.59,8.63,8.63,0,0,1-2.52,6.12,8.49,8.49,0,0,1,3.42,6.89,8.15,8.15,0,0,1-3.35,6.74,13.88,13.88,0,0,1-8.76,2.62h-16V120Zm-5.85,8v3.83H500a2.7,2.7,0,0,0,1.8-.57,1.71,1.71,0,0,0,.67-1.37,1.66,1.66,0,0,0-.67-1.35A2.8,2.8,0,0,0,500,128Zm0,11.3v4.23h6.48a2.87,2.87,0,0,0,1.91-.59,1.93,1.93,0,0,0,.7-1.57,1.87,1.87,0,0,0-.72-1.47,2.86,2.86,0,0,0-1.89-.6Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M515.09,142.77a8.91,8.91,0,0,0,3.65.72q4.46,0,4.45-4.32V120h9.54v20.65a10.85,10.85,0,0,1-3.46,8.37,12.83,12.83,0,0,1-9,3.19q-3.74,0-5.13-1Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M538.63,120h24.3v8H548.12v3.74h12.74v7.74H548.12v4.05h15.26v8H538.63Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M586.06,128V151.5h-9.5V128h-9.49v-8h28.48v8Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M600,120h9.49v31.5H600Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M613.69,120H624L631,139.21,637.76,120h10.35L635.2,151.5h-8.51Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M653.92,123.91a17.15,17.15,0,0,1,23.44,0,17.55,17.55,0,0,1,0,23.67,17.15,17.15,0,0,1-23.44,0,17.55,17.55,0,0,1,0-23.67Zm6.81,17.39a6.57,6.57,0,0,0,9.79,0,8.92,8.92,0,0,0,0-11.11,6.59,6.59,0,0,0-9.79,0,9,9,0,0,0,0,11.11Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M409.59,205.5l13-31.5h8.5L444,205.5H433.67l-1.53-4.37H421.52l-1.58,4.37Zm19.71-12.33-2.43-6.89-2.47,6.89Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M448.25,174h9.49v23.49H472v8H448.25Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M496.67,187.27a7.17,7.17,0,0,0,.22-1.75,3,3,0,0,0-1.53-2.5,7.76,7.76,0,0,0-9.22,1.17,8.94,8.94,0,0,0-.05,11.16,6.71,6.71,0,0,0,5.22,2.14,6,6,0,0,0,4.16-1.38,5.32,5.32,0,0,0,1.78-3.62h9a14.36,14.36,0,0,1-4.95,9.86,15.84,15.84,0,0,1-10.8,3.86,15.08,15.08,0,0,1-11.43-4.61,17.81,17.81,0,0,1,.2-23.69q4.62-4.64,12.09-4.63a16.33,16.33,0,0,1,10.39,3.21,10,10,0,0,1,4.1,8.22,6.49,6.49,0,0,1-.5,2.56Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M507.92,205.5l13-31.5h8.51l12.91,31.5H532l-1.53-4.37H519.84l-1.57,4.37Zm19.71-12.33-2.43-6.89-2.48,6.89Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M546.57,174h6.21l14.36,15V174h9.27v31.5h-6.53l-14.08-15v15h-9.23Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M582.21,205.5v-5.22l13-18.32H582.44v-8h26.32v5.22l-13,18.27H609v8Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M613,205.5,626,174h8.5l12.92,31.5H637l-1.53-4.37H624.87l-1.58,4.37Zm19.7-12.33-2.43-6.89-2.47,6.89Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M651.6,174h13.72a16.82,16.82,0,0,1,12,4.43,14.85,14.85,0,0,1,4.7,11.32,14.65,14.65,0,0,1-4.79,11.38,17.08,17.08,0,0,1-11.95,4.37H651.6Zm13.72,23.49a6.8,6.8,0,0,0,5.2-2.19,7.75,7.75,0,0,0,2.05-5.55,7.87,7.87,0,0,0-2.05-5.61,6.83,6.83,0,0,0-5.2-2.18H661.1v15.53Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M690.62,177.91a17.15,17.15,0,0,1,23.44,0,17.55,17.55,0,0,1,0,23.67,17.15,17.15,0,0,1-23.44,0,17.55,17.55,0,0,1,0-23.67Zm6.81,17.39a6.2,6.2,0,0,0,4.88,2.19,6.27,6.27,0,0,0,4.91-2.19,9,9,0,0,0,0-11.11,6.26,6.26,0,0,0-4.91-2.18,6.19,6.19,0,0,0-4.88,2.18,9,9,0,0,0,0,11.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObj100Mvl);
export default __webpack_public_path__ + "static/media/Obj_100-mvl.96e7cb418f8d1de02da1cb7879e35a15.svg";
export { ForwardRef as ReactComponent };